const Clock = ({
  size = 20,
  width,
  height,
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 55.668 55.668"
    width={width ?? size}
    height={height ?? size}
    fill={color}
    {...props}
  >
    <path d="M27.833 0C12.487 0 0 12.486 0 27.834s12.487 27.834 27.833 27.834c15.349 0 27.834-12.486 27.834-27.834S43.182 0 27.833 0zm0 51.957c-13.301 0-24.122-10.821-24.122-24.123S14.533 3.711 27.833 3.711c13.303 0 24.123 10.821 24.123 24.123S41.137 51.957 27.833 51.957z" />
    <path d="M41.618 25.819H29.689V10.046a1.856 1.856 0 0 0-1.855-1.856 1.856 1.856 0 0 0-1.854 1.856v19.483h15.638a1.856 1.856 0 0 0 0-3.71z" />
  </svg>
);

export default Clock;
